"use client";

import React from "react";
import { useRouter } from "next/navigation";
import { Search } from "lucide-react";

interface SearchComponentProps {
  onFocus?: () => void;
  onBlur?: () => void;
}

const SearchComponent: React.FC<SearchComponentProps> = ({
  onFocus,
  onBlur,
}) => {
  const router = useRouter();

  const handleFocus = () => {
    onFocus?.();
    router.push("/search");
  };

  return (
    <div className="relative">
      <div className="relative" onClick={handleFocus}>
        <div
          className="w-full h-10 pl-10 pr-4 py-2 rounded-full 
             bg-muted/50 dark:bg-muted/30 
             border border-input dark:border-gray-700 
             focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:border-transparent 
             hover:cursor-pointer transition-colors"
          onClick={handleFocus}
        >
          <Search
            className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground"
            onClick={handleFocus}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchComponent;
